module.exports = __webpack_public_path__ + "static/img/yapeiAL2.2374504.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/yapeiAL2.jpg
// module id = T3d/
// module chunks = 0